import { LoadStatus } from '../load-status';

export const MEASUREMENT_TOOLS_FEATURE_KEY = 'measurementTools';

/**
 * Serializable shape of a measurement tool — the data fields of
 * {@link MeasurementToolsDetailsModel} without the class.  `calibratedDate` is kept as
 * the raw OData date string (`Mwert1`) so the slice is JSON-safe for persistence; the
 * facade converts it back to a `moment.Moment` via `TimeUtilities.momentFromDateAndTime`
 * on read.
 */
export type MeasurementToolState = Readonly<{
    technicalId: string;
    descriptionDropdownText: string;
    calibratedDate: string;
    gid: string;
    message: string;
}>;

export type MeasurementToolsCollectionState = Readonly<{
    tools: MeasurementToolState[];
    status: LoadStatus;
}>;

export const initialMeasurementToolsState: MeasurementToolsCollectionState = {
    tools: [],
    status: LoadStatus.Idle,
};
